import { ReactNode } from 'react';
import { Badge } from '@/components/ui/badge';
import { CheckCircle } from 'lucide-react';
import Footer from '@/components/Footer';

interface AuthMobileProps {
  children: ReactNode;
  invitationToken?: string | null;
  familyName?: string | null;
  invitationDetails?: any;
}

export const AuthMobile = ({ children, invitationToken, familyName, invitationDetails }: AuthMobileProps) => {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Header avec image de famille et overlay */}
      <div className="relative pt-safe-area-top overflow-hidden">
        {/* Photo de famille en arrière-plan */}
        <img 
          src="/hero-family.jpg" 
          alt="Familie" 
          className="absolute inset-0 w-full h-full object-cover"
        />
        {/* Overlay noir transparent */}
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="relative px-6 py-8 pb-16 text-left text-white">
          {/* Logo */}
          <div className="flex justify-start mb-4">
            <div className="bg-[#3d1561] rounded-full p-3">
              <img src="/logo-simplified.png" alt="Clan" className="h-6 w-6" />
            </div>
          </div>
          
          {/* Message de bienvenue */}
          <div className="space-y-3 pb-4 text-white">
            <h1 className="text-2xl font-bold mb-2">
              {invitationToken ? 'Rejoignez votre famille' : 'Bienvenue sur Clan'}
            </h1>
            <p className="text-white/90 text-base leading-relaxed max-w-xs pb-4">
              Le quartier général de votre famille
            </p>
            
            {/* Badge d'invitation */}
            {invitationToken && familyName && (
              <div className="pt-2">
                <Badge variant="secondary" className="bg-white/15 text-white border-white/20 backdrop-blur-sm">
                  <CheckCircle className="h-4 w-4 mr-2" />
                  Invitation en attente
                </Badge>
              </div>
            )}
            
            {/* Détails du profil invité */}
            {invitationDetails?.personDetails && (
              <div className="pt-3 text-sm text-white/80">
                <p>Votre profil :</p>
                <p className="font-medium">
                  {invitationDetails.personDetails.firstName} {invitationDetails.personDetails.lastName}
                  {invitationDetails.personDetails.category === 'family' && invitationDetails.personDetails.familyRole && (
                    <span className="ml-2 text-white/70">
                      • {invitationDetails.personDetails.familyRole === 'son' ? 'Fils' : 
                        invitationDetails.personDetails.familyRole === 'daughter' ? 'Fille' :
                        invitationDetails.personDetails.familyRole === 'spouse' ? 'Conjoint(e)' :
                        invitationDetails.personDetails.familyRole}
                    </span>
                  )}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      
      {/* Zone formulaire avec marge négative et coins arrondis */}
      <div className="flex-1 relative -mt-16 bg-content-warm rounded-t-3xl pt-6 flex flex-col">
        <div className="flex-1 px-6 pb-8">
          <div className="max-w-sm mx-auto">
            {children}
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};